import styled from 'styled-components';
import { Text } from '@perch-labs/shrike';

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FieldLabel = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  color: ${props => props.theme.colors.content.primary};
`;

export const FieldDescription = styled(Text)`
  margin: 0;
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const OptionLabel = styled.label<{ $isEnabled: boolean }>`
  display: flex;
  align-items: flex-start;
  cursor: ${props => (props.$isEnabled ? 'pointer' : 'not-allowed')};
  opacity: ${props => (props.$isEnabled ? 1 : 0.5)};
  font-weight: 400;

  /* Override Shrike Radio's internal label which uses DM Sans Medium */
  label {
    font-family: 'DM Sans Regular';
    font-weight: 400;
  }
`;

export const DisclaimerContainer = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const DisclaimerText = styled(Text)`
  margin: 0;
`;
